<div class="common-modal__container-feedback">
  <!-- Cabecera -->
  <div class="common-status-message__jt-container-success">
    <i class="lf-icon-check-round-full common-status-message__icon-xl"></i>
    <span class="common-status-message__jt-title">Publicación finalizada</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content-header-feedback-info">{{configuration.textInfo}}</div>
  <div class="common-modal__content-header-feedback-info">
    <button class="common-button__link-inline">
      <a class="common-button__link-text-inline"
        [href]="configuration.concept.url"
        target="_blank">
        <span-tooltip class="w-full"
          [text]="configuration.concept.url"></span-tooltip>
      </a>
    </button>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button-with-text-menu
      [item]="publishedConceptModal.shareUrlItem"
      [buttonClass]="'common-button__text-noborder'"
      [textButton]="'public-link.share-url' | afTranslate"
      [multiline]="1"
      (launchActionEmitter)="launchActionLink($event.option)">
    </button-with-text-menu>
    <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title">Aceptar</span>
    </button>
  </div>
</div>
